var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"status-filter"},[_c('sk-multiselect',{attrs:{"items-list":_vm.jobStatuses,"preselected-value":_vm.status,"default-value":_vm.statusValue},on:{"checkboxeschanged":_vm.onInputBoxChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }